import toast from 'react-hot-toast';

export const handleContractErrorToasts = (contractError: Error | null) => {
  if (!contractError) return;

  switch (contractError.name) {
    case 'EstimateGasExecutionError':
    case 'InsufficientFundsError':
    case 'ContractFunctionExecutionError':
      toast.error('Your account has insufficient funds to pay for gas fees that involve the transaction', {
        style: { textWrap: 'nowrap' },
      });
      return;

    case 'ConnectorNotConnectedError':
      toast.error('Your wallet is not connected to the site. Please, check the connection or restart the session.', {
        duration: 6000,
        style: { wordBreak: 'keep-all' },
      });
      return;

    default:
      toast.error(contractError.message);
      return;
  }
};
